import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearUser } from "@store/slices/userSlice";
import { clearAuthData } from "@utils/auth";
import { BROWSER_ROUTES } from "@constants/browser.routes";
import { resetUnauthorizedFlag } from "@config/axios/axios.config";
import { markPostLogoutRedirect } from "@utils/authRedirect";

export const useLogout = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [showLogoutModal, setShowLogoutModal] = useState(false);

	const handleLogoutClick = () => {
		setShowLogoutModal(true);
	};

	const handleLogoutConfirm = () => {
		// Set the bypass flag BEFORE clearing auth state.
		// Otherwise `AuthGuard` re-renders on the protected page and generates `returnTo`.
		markPostLogoutRedirect();

		// Navigate away first so `AuthGuard` doesn't compute `returnTo` for the
		// protected page we are leaving.
		navigate(BROWSER_ROUTES.LOGIN, { replace: true });

		resetUnauthorizedFlag();
		dispatch(clearUser());
		clearAuthData();
		setShowLogoutModal(false);
	};

	const handleLogoutCancel = () => {
		setShowLogoutModal(false);
	};

	return {
		handleLogout: handleLogoutClick,
		handleLogoutConfirm,
		handleLogoutCancel,
		showLogoutModal,
	};
};
